__turbopack_context__.v({
  "className": "caveat_8e861b19-module__1VdACa__className",
});
